import { ActionSituationFilter, IGroupersActions } from "./interface";

const updateGrouperCountAction = (grouper: IGroupersActions, prevSituation: string, newSituation: string) => {
	const updateGrouper = grouper;
	
	if(prevSituation === newSituation)
		return updateGrouper;

	switch(prevSituation){
	case ActionSituationFilter.NOT_STARTED:
		updateGrouper.notStarted -= 1;
		updateGrouper.count -= 1;
		break;
	case ActionSituationFilter.NEXT_TO_EXPIRE:
		updateGrouper.nextToExpire -= 1;
		updateGrouper.count -= 1;
		break;
	case ActionSituationFilter.IN_PROGRESS:
		updateGrouper.started -= 1;
		updateGrouper.count -= 1;
		break;
	case ActionSituationFilter.FINISHED:
		updateGrouper.finished -= 1;
		updateGrouper.count -= 1;
		break;
	case ActionSituationFilter.DRAFT:
		updateGrouper.draft -= 1;
		updateGrouper.count -= 1;
		break;
	case ActionSituationFilter.DELAYED:
		updateGrouper.delayed -= 1;
		updateGrouper.count -= 1;
		break;
	case ActionSituationFilter.CANCELED:
		updateGrouper.canceled -= 1;
		updateGrouper.count -= 1;
		break;
	default: 
		break;
	}
	switch(newSituation){
	case ActionSituationFilter.NOT_STARTED:
		updateGrouper.notStarted += 1;
		updateGrouper.count += 1;
		break;
	case ActionSituationFilter.NEXT_TO_EXPIRE:
		updateGrouper.nextToExpire += 1;
		updateGrouper.count += 1;
		break;
	case ActionSituationFilter.IN_PROGRESS:
		updateGrouper.started += 1;
		updateGrouper.count += 1;
		break;
	case ActionSituationFilter.FINISHED:
		updateGrouper.finished += 1;
		updateGrouper.count += 1;
		break;
	case ActionSituationFilter.DRAFT:
		updateGrouper.draft += 1;
		updateGrouper.count += 1;
		break;
	case ActionSituationFilter.DELAYED:
		updateGrouper.delayed += 1;
		updateGrouper.count += 1;
		break;
	case ActionSituationFilter.CANCELED:
		updateGrouper.canceled += 1;
		updateGrouper.count += 1;
		break;
	default: 
		break;
	}

	return updateGrouper;
};

export const updateGrouperPercentAction = (grouper: IGroupersActions, prevPercent: number, newPercent: number) => {
	const updateGrouper = grouper;
	
	if(prevPercent === newPercent)
		return updateGrouper;

	if(updateGrouper.percentage === null)
		updateGrouper.percentage = 0;

	updateGrouper.percentage -= prevPercent / updateGrouper.count;
	updateGrouper.percentage += newPercent / updateGrouper.count;
	
	return updateGrouper;
};

export default updateGrouperCountAction;
